import _ from 'lodash'

export const getGym = gymId => {
  const docRef = window.firebaseDb.collection('gyms')
  const query = docRef.where('id', '==', gymId)
  let data = {}
  return query
    .get()
    .then(docSnapshot => {
      if (!docSnapshot.docs.length) {
        return data
      } else {
        data = docSnapshot.docs[0].data()
        // TODO: NATE: Use deep copy?
        return Object.assign({}, data, {key: docSnapshot.docs[0].id})
      }
    })
    .catch(function (error) {
      console.log('Error getting document:', error)
    })
}

export const getLatestProblems = gymId => {
  const docRef = window.firebaseDb.collection('problems')
  const query = docRef
    .where('gymId', '==', gymId)
    .orderBy('timestamp', 'desc')
    .limit(5)
  let data = {}
  return query
    .get()
    .then(docSnapshot => {
      if (!docSnapshot.docs.length) {
        return data
      } else {
        data = docSnapshot.docs.map(d => {
          return Object.assign({}, d.data(), {key: d.id})
        })
        // TODO: NATE: Use deep copy?
        return Object.assign([], data)
      }
    })
    .catch(function (error) {
      console.log('Error getting document:', error)
    })
}

export const findProblem = (problemKey, problems) => {
  let res
  _.each(problems, problem => {
    if (problemKey === problem.key) {
      res = problem
      return false
    }
  })
  return res
}

export const grades = [
  {numberGrade: 0, vgrade: 'v0', font: '4'},
  {numberGrade: 1, vgrade: 'v1', font: '5'},
  {numberGrade: 2, vgrade: 'v2', font: '5+'},
  {numberGrade: 3, vgrade: 'v3', font: '6A'},
  {numberGrade: 4, vgrade: 'v4', font: '6B'},
  {numberGrade: 5, vgrade: 'v5', font: '6C'},
  {numberGrade: 6, vgrade: 'v6', font: '7A'},
  {numberGrade: 7, vgrade: 'v7', font: '7A+'},
  {numberGrade: 8, vgrade: 'v8', font: '7B'},
  {numberGrade: 9, vgrade: 'v9', font: '7C'},
  {numberGrade: 10, vgrade: 'v10', font: '7C+'},
  {numberGrade: 11, vgrade: 'v11', font: '8A'},
  {numberGrade: 12, vgrade: 'v12', font: '8A+'},
  {numberGrade: 13, vgrade: 'v13', font: '8B'},
  {numberGrade: 14, vgrade: 'v14', font: '8B+'},
  {numberGrade: 15, vgrade: 'v15', font: '8C'},
  {numberGrade: 16, vgrade: 'v16', font: '8C+'},
]

// future proofing for language
export const feet = [
  {index: '0', text: 'tracking (pieds mains)'},
  {index: '1', text: 'any feet (pieds libre)'},
  {index: '2', text: 'screw ons (pieds grattes)'},
]

export const sortHolds = holds => {
  let sortedHolds = Object.assign([], holds)
  let area_a, area_b
  sortedHolds.sort((a, b) => {
    area_a = (a.xmax - a.xmin) * (a.ymax - a.ymin)
    a.area = area_a
    area_b = (b.xmax - b.xmin) * (b.ymax - b.ymin)
    b.area = area_b
    return area_b - area_a
  })
  return sortedHolds
}



// WEBPACK FOOTER //
// ./src/helpers/gymHelpers.js